import { T } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'

interface Props {
  isProbing: boolean
  isLoading: boolean
  revalidate: () => void
}
export const Revalidate = ({ isProbing, isLoading, revalidate }: Props) => (
  <Button
    loading={isProbing}
    disabled={isLoading}
    variant="primary"
    onClick={() => {
      revalidate()
    }}
  >
    <T defaultMessage="Revalidate DNS settings" id="Admin.Domain.ValidateDns" />
  </Button>
)
